/**
 * Alert — inline status message.
 * variant: info | success | warning | error
 */
import React from 'react';

export default function Alert({ variant = 'info', title, message }) {
  return (
    <div className={`alert alert-${variant}`} role="alert">
      {title && <strong className="alert-title">{title}</strong>}
      {message && <span className="alert-message">{message}</span>}
    </div>
  );
}
